import { WmkLink } from "wmk-link";
import { colors } from "../ui/colors";
import { Col, Container, Row } from "react-bootstrap";
import { graphql, useStaticQuery } from "gatsby";
import { ContentfulImageQuery, Img, WmkImage } from "wmk-image";
import styled from "styled-components";
import React, { useState, useEffect } from "react";

const HeaderContainer = styled(Container)<{
  dark?: boolean;
  width: number;
  display?: boolean;
}>`
  padding: 3rem 0;
  margin-left: 0;
  ${({ dark, width }) =>
    dark && width > 992
      ? "height: 0; width: 0 ; padding: 0;"
      : dark
      ? `color: white; background: ${colors.darkPurple.getHex()}; border-bottom: 10px solid ${colors.accentOrange.getHex()}`
      : ""};
  .row {
    display: flex;
    justify-content: center;
  }
  .line {
    height: 1rem;
    width: 100%;
    background: ${colors.accentOrange.getHex()};
  }
  ${({ display }) => (display ? "none" : "")}
`;

const Header = ({ is404 }: { is404?: boolean }) => {
  const [viewWidth, setViewWidth] = useState(0);
  const [path, setPath] = useState("");

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    const winWidth = window.innerWidth;
    setViewWidth(winWidth);
  };

  useEffect(() => {
    const path = location?.pathname ? location.pathname : "";
    setPath(path);
  }, []);

  const isVideoDisplay =
    (path &&
      path !== "/gallery/" &&
      path !== "/gallery" &&
      path !== "/" &&
      path !== "/crm" &&
      path !== "/inbound" &&
      !is404) ||
    (is404 && viewWidth < 992);

  const data: HeaderQuery = useStaticQuery(headerQuery);
  const image = new Img(data.logo);

  return (
    <HeaderContainer
      dark={path && isVideoDisplay ? "true" : undefined}
      fluid
      width={viewWidth}
      display={path && isVideoDisplay && viewWidth < 992 ? "true" : undefined}
      is404={is404 ? "true" : ""}>
      <Row style={{ width: "100%", marginLeft: 0, marginRight: 0 }}>
        <Col md={2} xs={4} sm={3} className="col">
          <WmkLink to="/">
            <WmkImage image={image} />{" "}
          </WmkLink>
        </Col>
      </Row>
      {/* {dark && <div className="line"></div>} */}
    </HeaderContainer>
  );
};

export default Header;

interface HeaderQuery {
  logo: ContentfulImageQuery;
}

const headerQuery = graphql`
  {
    logo: contentfulAsset(title: { eq: "WMK-Icon" }) {
      gatsbyImageData(quality: 80)
      title
      file {
        url
        contentType
      }
      description
    }
  }
`;
